/*
* 导出明细设置
 */
import React from 'react'
import {connect} from 'dva'
import {component_tool, framework_tool} from '@/tool'
import {handleExport} from "../../../utils";

let {WizContainer, WizAvatarUpload, ossFileUtils} = framework_tool
import {modelUtils} from "@/utils";

const {WizButton, WizSpin, WizRow, WizCol, WizForm, WizComponent, WizInput, WizModal, Wizmessage} = component_tool


class ExamExportDetail extends WizContainer {

  componentName = 'ExamExportDetail'

  constructor(props) {
    super(props)
    const {data} = props;
    const {examIdList} = data;
    let max = examIdList ? examIdList.length : 0;
    this.state = {
      examIdList,
      max
    }
  }

  _componentDidMount() {

  }

  propsAndStateOnChange = {
    examEverydayRecordReport: this._examEverydayRecordReport.bind(this),
  };

  _examEverydayRecordReport(nextProps, nextState) {
    handleExport({title: '天天学练考试记录明细', column: []}, nextProps, nextState, 'examEverydayRecordReport')
    let {changeModal} = nextProps;
    changeModal && changeModal(false, true);
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    if (fitterValues && fitterValues['imgFileId'] && fitterValues['imgFileId'].length) {
      fitterValues.imgFileId = fitterValues.imgFileId[0].fileId;//icon获取对应上传实体的fileId
    } else {
      fitterValues.imgFileId = null;
    }
    return fitterValues;
  }

  _exportExamDetailReport = e => {
    this.formData.validateFields((err, values) => {
      if (!err) {
        this.doAction({
          path: "examEveryday/examEverydayRecordReport",
          payload: {
            key: "examEverydayRecordReportKey",
            apiParams: {
              ...values
            }
          }
        });
      }
      return
    });
  }

  _reset = () => {
    let {changeModal} = this.props;
    changeModal && changeModal(false)
  }

  _returnForm = () => {
    const {examEverydayLoading} = this.props
    const {max, examIdList} = this.state;
    let formColumns = [
      {
        name: 'examIdList',
        formItem: {
          type: 'hidden',
          initialValue: examIdList
        }
      },
      {
        title: '需完成天数',
        name: 'finishExamCount',
        formItem: {
          type: 'number',
          precision: 0,
          placeholder: '请输入需完成天数',
          min: 1,
          max: max,
          rules: [{
            required: true,
            message: '请输入需完成天数',
          }],
        }
      }]
    const footer = () => {
      return (
        <div className='form-btns'>
          <WizButton onClick={this._reset.bind(this)}>取消</WizButton>
          <WizButton type='primary' htmlType='submit'>
            确认
          </WizButton>
        </div>
      )
    }
    let formProps = {
      ref: 'form',
      columns: formColumns,
      onSubmit: this._exportExamDetailReport,
      record: null,
      preview: null,
      footer: footer(),
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 14}
      }
    }
    return (
      <WizSpin tip={''} spinning={examEverydayLoading}>
        <WizRow>
          <WizCol offset={3}>
            <strong>{'提示：您当前共选择了' + max + '场考试，请设定“需完成天数”'}</strong>
          </WizCol>
        </WizRow>
        <WizRow>
          <WizForm {...formProps}
                   ref={r => {
                     this.formData = r
                   }}
          />
        </WizRow>
      </WizSpin>
    )
  }

  render() {
    return (
      this._returnForm()
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {examEveryday} = state;
  const examEverydayRecordReport = modelUtils.getModelEntity(examEveryday, 'examEverydayRecordReportKey');
  const load = modelUtils.getLoadingState(state, ['examEveryday']);
  return {
    examEverydayRecordReport,
    ...load
  }
}
const options = {withRef: true}

export default connect(mapStateToProps, null, null, options)(ExamExportDetail)



